import ownershipTypeReducer from './ownershipTypeSlice';
import * as ownershipTypeActions from './actions';
import * as ownershipTypeSelector from './selector';

export {
  ownershipTypeActions,
  ownershipTypeSelector
}

export default ownershipTypeReducer